import React from 'react';
import Page from 'app/components/layout/Page';
import BadGateway from 'app/components/pages/BadGateway';
import ContentSpinner from 'app/components/presentation/loading/ContentSpinner';
import makeLazyLoadingWrapper from 'app/components/mixins/makeLazyLoadingWrapper';

const wrapComponent = makeLazyLoadingWrapper({
  LoadingComponent: () => (
    <Page>
      <ContentSpinner />
    </Page>
  ),

  ErrorComponent: BadGateway,
});

export const makeLazyPageBase = <T extends React.ComponentType<any>>(
  getComponent: () => Promise<T>,
) => wrapComponent(getComponent);

export default <T extends React.ComponentType<any>>(
  getModule: () => Promise<{ default: T }>,
) => makeLazyPageBase(
  async () => (await getModule()).default,
);
